import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ClearInstallmentPlanFetchingError } from '../../../ngxs/installments/installments.actions';
import { ClearInvoiceFetchingError } from '../../../ngxs/invoice/invoice.actions';

@Component({
  selector: 'app-credit-decision',
  templateUrl: './credit-decision-dialog.component.html',
  styleUrls: ['./credit-decision-dialog.component.css'],
})
export class CreditDecisionDialogComponent {
  public title: string;
  public reason: string;
  public buttons: any[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreditDecisionDialogComponent>,
    private store: Store
  ) {
    this.title =
      data.title || 'Tyvärr kan vi inte bevilja dig den valda betalmetoden.';
    this.reason =
      data.reason ||
      'Beslutet baserar sig på en helhetsbedömning utifrån vår kreditprövning.';
    this.buttons = data.buttons;
  }

  handleButtonClick(button: any): void {
    this.closeSelf();
    button.callback.call();
  }

  private closeSelf(): void {
    this.dialogRef.close();
    this.store.dispatch(new ClearInstallmentPlanFetchingError());
    this.store.dispatch(new ClearInvoiceFetchingError());
  }
}
